module.exports = __webpack_public_path__ + "img/pic1-1.d3fd1d6a.png";